<template>
  <div id="events-bidding-approval">
    <v-card elevation="24" class="approval-card">
      <!-- Premium Header -->
      <div class="header-section">
        <div class="header-gradient">
          <v-row align="center" justify="space-between" class="pa-6">
            <v-col cols="12" md="8">
              <div class="d-flex align-center">
                <div class="header-icon-box">
                  <v-icon size="40" color="white">mdi-clipboard-check-outline</v-icon>
                </div>
                <div class="ml-4">
                  <h2 class="header-title white--text mb-1">{{ pageTitle }}</h2>
                  <p class="header-subtitle white--text mb-0">
                    Review and approve event bidding proposals
                  </p>
                </div>
              </div>
            </v-col>
            <v-col cols="12" md="4" class="text-right">
              <v-btn
                icon
                dark
                large
                @click="closePrompt"
                class="close-btn"
              >
                <v-icon>mdi-close-circle-outline</v-icon>
              </v-btn>
            </v-col>
          </v-row>
        </div>
      </div>

      <!-- Content Section -->
      <v-container class="content-section">
        <!-- Loading State -->
        <div v-if="LoadingFlag" class="text-center py-12">
          <v-progress-circular :size="70" :width="7" color="primary" indeterminate></v-progress-circular>
          <p class="mt-4 text-h6 primary--text">Loading approval data...</p>
        </div>

        <!-- Form Content -->
        <v-form
          ref="form1"
          v-model="valid1"
          lazy-validation
          v-if="!LoadingFlag"
          @submit.prevent="confirmAlert"
        >
          <!-- Event Details Grid -->
          <div class="details-section mb-6">
            <div class="section-header mb-4">
              <v-icon color="primary" size="28" class="mr-2">mdi-information-outline</v-icon>
              <span class="section-title">Event Details</span>
            </div>

            <v-row wrap>
              <v-col cols="12" sm="6" lg="3" md="3">
                <div class="detail-card">
                  <div class="detail-icon">
                    <v-icon color="white" size="24">mdi-calendar-check</v-icon>
                  </div>
                  <div class="detail-label">Event Name</div>
                  <div class="detail-value">{{ recordData.EventName }}</div>
                </div>
              </v-col>

              <v-col cols="12" sm="6" lg="3" md="3">
                <div class="detail-card">
                  <div class="detail-icon">
                    <v-icon color="white" size="24">mdi-map-marker</v-icon>
                  </div>
                  <div class="detail-label">Zone Name</div>
                  <div class="detail-value">{{ recordData.ZoneName }}</div>
                </div>
              </v-col>

              <v-col cols="12" sm="6" lg="3" md="3">
                <div class="detail-card">
                  <div class="detail-icon">
                    <v-icon color="white" size="24">mdi-office-building</v-icon>
                  </div>
                  <div class="detail-label">LO Name</div>
                  <div class="detail-value">{{ recordData.LoName }}</div>
                </div>
              </v-col>

              <v-col cols="12" sm="6" lg="3" md="3">
                <div class="detail-card">
                  <div class="detail-icon">
                    <v-icon color="white" size="24">mdi-home-map-marker</v-icon>
                  </div>
                  <div class="detail-label">Proposed Venue</div>
                  <div class="detail-value">{{ recordData.VenueDetails }}</div>
                </div>
              </v-col>

              <v-col cols="12" sm="6" lg="3" md="3">
                <div class="detail-card">
                  <div class="detail-icon">
                    <v-icon color="white" size="24">mdi-calendar-range</v-icon>
                  </div>
                  <div class="detail-label">Proposal Dates</div>
                  <div class="detail-value">{{ recordData.ProposalDates }}</div>
                </div>
              </v-col>

              <v-col cols="12" sm="6" lg="3" md="3">
                <div class="detail-card">
                  <div class="detail-icon">
                    <v-icon color="white" size="24">mdi-check-decagram</v-icon>
                  </div>
                  <div class="detail-label">Current Status</div>
                  <v-chip
                    :color="recordData.StatusColor"
                    dark
                    class="detail-chip mt-2"
                    small
                  >
                    {{ recordData.StatusTxt }}
                  </v-chip>
                </div>
              </v-col>
            </v-row>
          </div>

          <!-- Description Section -->
          <div class="description-section mb-6">
            <div class="section-header mb-4">
              <v-icon color="primary" size="28" class="mr-2">mdi-file-document-outline</v-icon>
              <span class="section-title">Proposal Description</span>
            </div>
            <v-card elevation="4" class="description-card">
              <v-card-text class="pa-4">
                <div v-html="recordData.Description" class="description-content"></div>
              </v-card-text>
            </v-card>
          </div>

          <!-- Reason Section -->
          <div class="reason-section mb-6">
            <div class="section-header mb-4">
              <v-icon color="primary" size="28" class="mr-2">mdi-comment-multiple-outline</v-icon>
              <span class="section-title">
                <span class="text-danger mr-1">*</span>Approval Reason
              </span>
            </div>
            <v-textarea
              outlined
              v-model="Reason"
              :rules="ReasonRules"
              label="Enter your approval or rejection reason"
              placeholder="Please provide detailed reason for this decision..."
              rows="5"
              counter
              maxlength="500"
              prepend-inner-icon="mdi-pencil-outline"
              class="reason-textarea"
            ></v-textarea>
          </div>

          <!-- Action Buttons -->
          <div class="action-section">
            <v-row wrap align="center" justify="center">
              <v-col cols="12" sm="6" md="3" class="text-center">
                <v-btn
                  :disabled="!valid1"
                  @click.prevent="confirmAlert(1)"
                  :loading="LoadingFlag"
                  elevation="12"
                  rounded
                  large
                  color="#10b981"
                  class="action-btn approve-btn white--text"
                  block
                >
                  <v-icon left size="24">mdi-check-circle</v-icon>
                  Approve
                </v-btn>
              </v-col>

              <v-col cols="12" sm="6" md="3" class="text-center">
                <v-btn
                  :disabled="!valid1"
                  @click.prevent="confirmAlert(3)"
                  :loading="LoadingFlag"
                  elevation="12"
                  rounded
                  large
                  color="#ff7f50"
                  class="action-btn reject-btn white--text"
                  block
                >
                  <v-icon left size="24">mdi-close-circle</v-icon>
                  Reject
                </v-btn>
              </v-col>

              <v-col cols="12" sm="6" md="3" class="text-center">
                <v-btn
                  @click="closePrompt"
                  elevation="12"
                  rounded
                  large
                  color="#6c757d"
                  class="action-btn close-action-btn white--text"
                  block
                >
                  <v-icon left size="24">mdi-close</v-icon>
                  Close
                </v-btn>
              </v-col>
            </v-row>
          </div>
        </v-form>
      </v-container>
    </v-card>
  </div>
</template>

<script>
import common from "@/view/Common.vue";
import companyConfig from "@/company_config.json";
import Swal from "sweetalert2";

export default {
  mixins: [common],
  components: {},
  props: {
    scoreRecordPrompt: {
      type: Boolean,
      required: true,
    },
    recordData: {
      required: true,
    },
    pageTitle: {
      type: String,
    },
    pageDescription: {
      type: String,
    },
  },
  data() {
    return {
      tableColumns1: [],
      tableOptions1: {},
      tableData1: [],

      valid1: true,

      row: {},
      ResultFlag: false,

      PreviewButtonFlag: false,
      Documentpath: "",
      ResultFlag: false,

      LoadingFlag: false,

      TableFlag1: false,

      selected: [],
      SearchFlag: false,
      search: "",

      ChairmanData: {},
      DirectorData: {},
      DocumentsData: [],
      FacultiesData: [],

      EfficiencyIdRules: [(v) => !!v || "100% Efficiency criteria is required"],
      EfficiencyId: "",
      EfficiencyIdOptions: [],
      EfficiencyIdOptionsLoading: false,

      Remarks: "",
      RemarksRules: [(v) => !!v || "Remarks is required"],

      ApproveLoadingFlag: false,
      RejectLoadingFlag: false,
      FilePreviewFlag: false,

      LomDataPageTitle: "",
      LomDataPreviewFlag: false,
      LomDataParams: {},

      Reason: "",
      ReasonRules: [(v) => !!v || "Reason is required"],
      menu1: false,
    };
  },
  computed: {},
  watch: {
    dialog(val) {
      val || this.close();
    },
    dialogDelete(val) {
      val || this.closeDelete();
    },
    row: function () {
      console.log("watch row");
      var tr = this.row;
      // var n1 = tr.length
      var n1 = Object.keys(tr).length;
      console.log("n1=" + n1 + ", tr=" + JSON.stringify(tr));
      this.EfficiencyId = "";
      if (n1 > 0) {
        this.EfficiencyId = tr.EfficiencyId;
        this.getEfficiencyIdOptions();
      }
    },
    EfficiencyIdOptions: function () {
      console.log("watch EfficiencyIdOptions");
      this.LoadingFlag = false;
      this.EfficiencyIdOptionsLoading = false;
    },
  },
  created() {
    // this.initialize()
  },
  methods: {
    closePrompt() {
      console.log("closePrompt called");
      this.$emit("hidePreviewRecordPrompt", this.ResultFlag);
    },
    validate() {
      console.log("validate is called");
      var result = this.$refs.form.validate();
      console.log("result=" + result);
      if (result) {
        this.addRecordDetails();
      } else {
        console.log("some errors occured");
      }
    },
    refreshPageData() {
      console.log("refreshPageData called");
      var recordData = this.recordData;
      console.log("recordData=" + JSON.stringify(recordData));
      this.getTableRecords();
      var recordData = this.recordData;
      console.log("recordData = " + JSON.stringify(recordData));
    },

    confirmAlert(status) {
      console.log({ status });
      var validate1 = this.$refs.form1.validate();
      console.log({ validate1 });

      if (validate1) {
        Swal.fire({
          title: "Do you want to continue?",
          text: "Please verify all the information before proceeding.",
          icon: "warning",
          showCancelButton: true,
          confirmButtonText: `Continue`,
          confirmButtonColor: "#3085d6",
          cancelButtonText: `Cancel`,
          cancelButtonColor: "#d33",
        }).then((result) => {
          /* Read more about isConfirmed, isDenied below */
          if (result.isConfirmed) {
            this.updateActiveStatus(status);
          } else {
            this.sweetAlert("error", "You cancelled the process", true);
          }
        });
      } else {
        var message = "Kindly fill the required fields";
        this.sweetAlert("error", message);
      }
    },
    updateActiveStatus(status) {
      console.log("updateActiveStatus is called");

      var validate1 = this.$refs.form1.validate();
      console.log({ validate1 });

      var Status = status;
      var Reason = this.Reason;
      var tr = this.recordData;
      console.log({ tr });

      var ProgramBid = this.ProgramBid;
      console.log({ Status }, { Reason }, { ProgramBid });

      if (validate1) {
        this.LoadingFlag = true;
        var server_url = companyConfig.apiURL;
        var token = this.$session.get("token");
        token = token == (null || undefined) ? 0 : token;
        var add_url = server_url + "api/events/bidding/event-status-update";
        var upload = {
          UserInterface: 1,
          Status: Status,
          Reason: Reason,
          ProgramBid: tr.ProgramBid,
          FromDate: tr.FromDate,
          ToDate: tr.ToDate,
          ProgramType: tr.ProgramTypeId,
          CityName: tr.CityId,
        };
        console.log("upload=" + JSON.stringify(upload));
        console.log(
          "server_url=" +
            server_url +
            ", token=" +
            token +
            ", add_url=" +
            add_url
        );

        const thisIns = this;
        var output = "";
        var records = "";
        var flag = 0;

        this.$http({
          url: add_url,
          method: "POST",
          data: upload,
          headers: {
            "Content-Type": "application/json",
            Authorization: "Bearer " + token,
          },
          onUploadProgress: function (progressEvent) {
            this.uploadPercentage = parseInt(
              Math.round((progressEvent.loaded / progressEvent.total) * 100)
            );
          }.bind(this),
        })
          .then(function (response) {
            console.log("response=" + JSON.stringify(response));
            thisIns.LoadingFlag = false;

            flag = response.data.flag;
            output = response.data.output;
            console.log("output=" + output + ", flag=" + flag);

            records = response.data.records;
            console.log({ records });

            if (flag == 1) {
              thisIns.sweetAlert("success", output, true);
              thisIns.ResultFlag = true;
              thisIns.closePrompt();
            } else {
              thisIns.sweetAlert("error", output, true);
            }
          })
          .catch(function (error) {
            console.log("error=" + error);
            thisIns.LoadingFlag = false;
          });
      } else {
        var message = "Kindly fill the required fields";
        this.sweetAlert("error", message);
      }
    },
  },
  beforeMount() {
    this.refreshPageData();
  },
};
</script>
<style lang="scss" scoped>
// Color Palette
$primary-color: #667eea;
$secondary-color: #764ba2;
$gradient-main: linear-gradient(135deg, $primary-color 0%, $secondary-color 100%);
$success-color: #10b981;
$warning-color: #ff7f50;
$danger-color: #f44336;
$grey-color: #6c757d;
$card-shadow: 0 16px 48px rgba(102, 126, 234, 0.15);
$input-shadow: 0 4px 12px rgba(102, 126, 234, 0.1);

// Animation Keyframes
@keyframes slideDown {
  from {
    opacity: 0;
    transform: translateY(-20px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}

@keyframes fadeInUp {
  from {
    opacity: 0;
    transform: translateY(20px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}

@keyframes slideInLeft {
  from {
    opacity: 0;
    transform: translateX(-30px);
  }
  to {
    opacity: 1;
    transform: translateX(0);
  }
}

@keyframes float {
  0%,
  100% {
    transform: translateY(0px);
  }
  50% {
    transform: translateY(-10px);
  }
}

@keyframes rotate {
  from {
    transform: rotate(0deg);
  }
  to {
    transform: rotate(360deg);
  }
}

#events-bidding-approval {
  .approval-card {
    border-radius: 16px !important;
    overflow: hidden;
    background: white !important;
    border: none;
    box-shadow: 0 20px 60px rgba(102, 126, 234, 0.2);
    animation: slideDown 0.6s cubic-bezier(0.34, 1.56, 0.64, 1);

    // ============================================
    // HEADER SECTION
    // ============================================
    .header-section {
      background: $gradient-main;
      position: relative;
      overflow: hidden;

      &::before {
        content: '';
        position: absolute;
        top: -50%;
        right: -50%;
        width: 200%;
        height: 200%;
        background: radial-gradient(circle, rgba(255, 255, 255, 0.1) 0%, transparent 70%);
        animation: rotate 20s linear infinite;
      }

      .header-gradient {
        position: relative;
        z-index: 1;
      }
    }

    .header-icon-box {
      background: rgba(255, 255, 255, 0.2);
      backdrop-filter: blur(10px);
      border-radius: 16px;
      padding: 12px;
      box-shadow: 0 8px 32px rgba(0, 0, 0, 0.15);
      animation: float 3s ease-in-out infinite;
    }

    .header-title {
      font-size: 28px;
      font-weight: 700;
      letter-spacing: 0.5px;
      text-shadow: 2px 2px 4px rgba(0, 0, 0, 0.2);
      animation: fadeInUp 0.8s ease-out;
    }

    .header-subtitle {
      font-size: 14px;
      opacity: 0.95;
      letter-spacing: 0.3px;
      animation: fadeInUp 1s ease-out;
    }

    .close-btn {
      background: rgba(255, 255, 255, 0.15) !important;
      backdrop-filter: blur(10px);
      transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
      border: 2px solid rgba(255, 255, 255, 0.2);

      &:hover {
        background: rgba(255, 255, 255, 0.25) !important;
        transform: scale(1.1) rotate(90deg);
        box-shadow: 0 8px 24px rgba(0, 0, 0, 0.2);
      }
    }

    // ============================================
    // CONTENT SECTION
    // ============================================
    .content-section {
      padding: 40px 24px;
      animation: fadeInUp 1s cubic-bezier(0.34, 1.56, 0.64, 1) 0.2s backwards;

      @media (max-width: 960px) {
        padding: 24px 16px;
      }

      @media (max-width: 600px) {
        padding: 16px 12px;
      }
    }

    // ============================================
    // SECTION HEADER
    // ============================================
    .section-header {
      display: flex;
      align-items: center;
      border-bottom: 3px solid $primary-color;
      padding-bottom: 12px;
      animation: slideInLeft 0.8s ease-out;

      .section-title {
        font-size: 18px;
        font-weight: 700;
        color: $primary-color;
        letter-spacing: 0.3px;
        text-transform: uppercase;
      }
    }

    // ============================================
    // DETAILS SECTION
    // ============================================
    .details-section {
      animation: fadeInUp 0.8s ease-out 0.1s backwards;

      .detail-card {
        background: linear-gradient(135deg, rgba(102, 126, 234, 0.08) 0%, rgba(118, 75, 162, 0.08) 100%);
        border: 2px solid rgba(102, 126, 234, 0.15);
        border-radius: 14px;
        padding: 18px;
        transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
        min-height: 160px;
        display: flex;
        flex-direction: column;
        justify-content: flex-start;
        box-shadow: 0 4px 12px rgba(0, 0, 0, 0.05);

        &:hover {
          transform: translateY(-8px);
          border-color: $primary-color;
          box-shadow: 0 12px 32px rgba(102, 126, 234, 0.2);
          background: linear-gradient(135deg, rgba(102, 126, 234, 0.12) 0%, rgba(118, 75, 162, 0.12) 100%);
        }

        .detail-icon {
          background: $gradient-main;
          border-radius: 50%;
          width: 48px;
          height: 48px;
          display: flex;
          align-items: center;
          justify-content: center;
          margin-bottom: 12px;
          box-shadow: 0 6px 16px rgba(102, 126, 234, 0.3);
        }

        .detail-label {
          font-size: 12px;
          font-weight: 700;
          color: #004e92;
          text-transform: uppercase;
          letter-spacing: 0.5px;
          margin-bottom: 8px;
        }

        .detail-value {
          font-size: 15px;
          font-weight: 600;
          color: #333;
          word-break: break-word;
          line-height: 1.4;
          flex-grow: 1;
        }

        .detail-chip {
          align-self: flex-start;
          font-weight: 700;
          letter-spacing: 0.3px;
          box-shadow: 0 2px 8px rgba(0, 0, 0, 0.15);
          transition: all 0.3s ease;

          &:hover {
            transform: translateY(-2px);
            box-shadow: 0 4px 12px rgba(0, 0, 0, 0.25);
          }
        }
      }
    }

    // ============================================
    // DESCRIPTION SECTION
    // ============================================
    .description-section {
      animation: fadeInUp 0.8s ease-out 0.2s backwards;

      .description-card {
        border: 2px solid rgba(102, 126, 234, 0.1);
        border-radius: 12px;
        background: linear-gradient(135deg, rgba(102, 126, 234, 0.03) 0%, rgba(118, 75, 162, 0.03) 100%);
        box-shadow: 0 4px 12px rgba(102, 126, 234, 0.1);

        .description-content {
          font-size: 14px;
          color: #333;
          line-height: 1.8;
          letter-spacing: 0.3px;

          h1, h2, h3, h4, h5, h6 {
            color: $primary-color;
            margin: 12px 0 8px 0;
            font-weight: 700;
          }

          p {
            margin: 8px 0;
          }

          ul, ol {
            margin: 12px 0;
            padding-left: 20px;

            li {
              margin: 4px 0;
            }
          }
        }
      }
    }

    // ============================================
    // REASON SECTION
    // ============================================
    .reason-section {
      animation: fadeInUp 0.8s ease-out 0.3s backwards;

      .reason-textarea {
        ::v-deep .v-input__slot {
          border-radius: 12px !important;
          border: 2px solid $primary-color !important;
          background: white !important;
          transition: all 0.3s ease;
          box-shadow: 0 2px 8px rgba(102, 126, 234, 0.1);

          textarea {
            font-size: 14px;
            line-height: 1.6;
            letter-spacing: 0.2px;
            color: #333;

            &::placeholder {
              color: #999;
              opacity: 0.7;
            }
          }
        }

        &:hover ::v-deep .v-input__slot {
          box-shadow: 0 4px 16px rgba(102, 126, 234, 0.2);
        }

        ::v-deep &.v-input--is-focused .v-input__slot {
          border-color: $secondary-color !important;
          box-shadow: 0 0 0 3px rgba(102, 126, 234, 0.15);
        }
      }
    }

    // ============================================
    // ACTION SECTION
    // ============================================
    .action-section {
      animation: fadeInUp 0.8s ease-out 0.4s backwards;
      margin-top: 32px;
      padding-top: 24px;
      border-top: 2px solid rgba(102, 126, 234, 0.1);

      .action-btn {
        font-weight: 700;
        letter-spacing: 0.5px;
        text-transform: uppercase;
        transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
        box-shadow: 0 6px 20px rgba(0, 0, 0, 0.15);

        &:hover:not(:disabled) {
          transform: translateY(-4px);
          box-shadow: 0 12px 32px rgba(0, 0, 0, 0.25);
        }

        &:active:not(:disabled) {
          transform: translateY(-2px);
        }

        &:disabled {
          opacity: 0.6;
          cursor: not-allowed;
        }

        .v-icon {
          font-size: 22px !important;
        }
      }

      .approve-btn {
        background: linear-gradient(135deg, $success-color 0%, #059669 100%) !important;

        &:hover:not(:disabled) {
          box-shadow: 0 12px 32px rgba(16, 185, 129, 0.4);
        }
      }

      .reject-btn {
        background: linear-gradient(135deg, $warning-color 0%, #e66e42 100%) !important;

        &:hover:not(:disabled) {
          box-shadow: 0 12px 32px rgba(255, 127, 80, 0.4);
        }
      }

      .close-action-btn {
        background: linear-gradient(135deg, $grey-color 0%, #5a6268 100%) !important;

        &:hover:not(:disabled) {
          box-shadow: 0 12px 32px rgba(108, 117, 125, 0.4);
        }
      }
    }

    // ============================================
    // RESPONSIVE DESIGN
    // ============================================
    @media (max-width: 1200px) {
      .header-title {
        font-size: 24px;
      }

      .section-title {
        font-size: 16px !important;
      }

      .detail-card {
        min-height: 140px;

        .detail-value {
          font-size: 14px;
        }
      }
    }

    @media (max-width: 960px) {
      .header-title {
        font-size: 20px;
      }

      .header-subtitle {
        font-size: 12px;
      }

      .header-icon-box {
        padding: 10px;

        ::v-deep .v-icon {
          font-size: 32px !important;
        }
      }

      .section-title {
        font-size: 14px !important;
      }

      .detail-card {
        min-height: 130px;
        padding: 12px;

        .detail-icon {
          width: 40px;
          height: 40px;
          margin-bottom: 8px;

          ::v-deep .v-icon {
            font-size: 20px !important;
          }
        }

        .detail-label {
          font-size: 11px;
        }

        .detail-value {
          font-size: 13px;
        }
      }

      .action-btn {
        font-size: 12px !important;
        padding: 8px 12px !important;

        .v-icon {
          font-size: 18px !important;
        }
      }
    }

    @media (max-width: 600px) {
      .header-section {
        ::v-deep .v-row {
          flex-direction: column;

          .v-col {
            text-align: center !important;
          }
        }
      }

      .header-title {
        font-size: 18px;
      }

      .header-subtitle {
        font-size: 11px;
      }

      .header-icon-box {
        margin: 0 auto 12px auto;
        width: fit-content;
      }

      .close-btn {
        margin: 12px auto 0 auto;
        display: block;
      }

      .content-section {
        padding: 12px 8px;
      }

      .section-header {
        flex-direction: column;
        align-items: flex-start;

        .v-icon {
          margin-bottom: 8px !important;
        }

        .section-title {
          font-size: 12px !important;
        }
      }

      .detail-card {
        min-height: auto;
        padding: 12px;
        margin-bottom: 8px;

        .detail-icon {
          width: 36px;
          height: 36px;
          margin-bottom: 8px;

          ::v-deep .v-icon {
            font-size: 18px !important;
          }
        }

        .detail-label {
          font-size: 10px;
        }

        .detail-value {
          font-size: 12px;
        }
      }

      .description-content {
        font-size: 12px !important;
      }

      .action-section {
        margin-top: 16px;
        padding-top: 16px;

        ::v-deep .v-col {
          margin-bottom: 8px;
        }
      }

      .action-btn {
        font-size: 10px !important;
        padding: 6px 8px !important;

        .v-icon {
          font-size: 16px !important;
          margin-right: 4px !important;
        }
      }
    }
  }

  // ============================================
  // UTILITY CLASSES
  // ============================================
  .text-danger {
    color: $danger-color;
  }

  .text-center {
    text-align: center;
  }

  .text-right {
    text-align: right;
  }

  .mr-1 {
    margin-right: 4px;
  }

  .mr-2 {
    margin-right: 8px;
  }

  .mr-3 {
    margin-right: 12px;
  }

  .mr-4 {
    margin-right: 16px;
  }

  .ml-4 {
    margin-left: 16px;
  }

  .mt-2 {
    margin-top: 8px;
  }

  .mb-1 {
    margin-bottom: 4px;
  }

  .mb-4 {
    margin-bottom: 16px;
  }

  .mb-6 {
    margin-bottom: 24px;
  }

  .py-12 {
    padding-top: 48px;
    padding-bottom: 48px;
  }

  .mt-4 {
    margin-top: 16px;
  }

  .d-flex {
    display: flex;
  }

  .align-center {
    align-items: center;
  }

  .white--text {
    color: white;
  }

  .pa-6 {
    padding: 24px;
  }

  .pa-4 {
    padding: 16px;
  }
}
</style>